/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateCustomerSupplyAppointmentsRequest model module.
* @module model/CreateCustomerSupplyAppointmentsRequest
* @version 2020-12-7
*/
export default class CreateCustomerSupplyAppointmentsRequest {
    /**
    * Constructs a new <code>CreateCustomerSupplyAppointmentsRequest</code>.
    * 供給予約作成レクエスト
    * @alias module:model/CreateCustomerSupplyAppointmentsRequest
    * @class
    * @param _date {Number} 予約の日付
    * @param reason {String} 理由
    */

    constructor(_date, reason) {
        
        
        this['date'] = _date;
        this['reason'] = reason;
        
    }

    /**
    * Constructs a <code>CreateCustomerSupplyAppointmentsRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCustomerSupplyAppointmentsRequest} obj Optional instance to populate.
    * @return {module:model/CreateCustomerSupplyAppointmentsRequest} The populated <code>CreateCustomerSupplyAppointmentsRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCustomerSupplyAppointmentsRequest();
                        
            
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Number');
            }
            if (data.hasOwnProperty('reason')) {
                obj['reason'] = ApiClient.convertToType(data['reason'], 'String');
            }
        }
        return obj;
    }

    /**
    * 予約の日付
    * @member {Number} date
    */
    'date' = undefined;
    /**
    * 理由
    * @member {String} reason
    */
    'reason' = undefined;




}
